import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from '../../utils/Breakpoints';
import { colors, nameToIcon } from '../../utils/config';
import Switch from '../Switch';

const StyledList = styled.ul`
	margin: 0 0 48px 0;
	padding: 0;
`;

const Item = styled.li`
	border-bottom: 1px solid ${colors.graylight};
	list-style-type: none;
	padding: 0 32px;

	${media.lg`
		padding: 0 48px;
	`}
`;

export default class List extends Component {
	constructor(props) {
		super(props);

		this.state = {
			items: this.props.items,
			allChecked: Object.keys(this.props.items).every(key => this.props.items[key] === 2),
		};

		if (this.props.passSetItems) {
			this.props.passSetItems(items => {
				this.setState({
					items,
					allChecked: Object.keys(items).every(key => items[key] === 2),
				});
			});
		}
	}

	// componentDidUpdate(prevProps, prevState) {
	componentDidUpdate() {
		this.props.onUpdate(this.state.items);
	}

	render() {
		const { keyPrefix, titleMappings } = this.props;
		const { items } = this.state;
		let { allChecked } = this.state;

		return (
			<StyledList>
				{Object.keys(items).length > 1 && (
					<Item>
						<Switch
							id={`${keyPrefix}-toggle-all`}
							value="1"
							label="Alle ein/ausblenden"
							defaultChecked={allChecked}
							onChange={checked => {
								if (allChecked !== checked) {
									allChecked = checked;
									Object.keys(items).forEach(item => {
										items[item] = checked * 2;
									});
									this.setState({ items, allChecked });
								}
							}}
						/>
					</Item>
				)}
				{Object.keys(items).map(item => {
					const label = titleMappings[item] || item;
					const icon = nameToIcon(label);
					return (
						<Item key={`${keyPrefix}-toggle-${icon}`}>
							<Switch
								id={`${keyPrefix}-toggle-${icon}`}
								value="1"
								label={label}
								icon={icon}
								defaultChecked={items[item] === 2}
								onChange={checked => {
									items[item] = checked * 2;
									if (checked === false && allChecked === true) {
										allChecked = false;
									} else if (checked === true && allChecked === false) {
										allChecked = Object.keys(items).every(
											key => items[key] === 2,
										);
									}
									this.setState({ items, allChecked });
								}}
							/>
						</Item>
					);
				})}
			</StyledList>
		);
	}
}

List.propTypes = {
	keyPrefix: PropTypes.string,
	items: PropTypes.object,
	titleMappings: PropTypes.object,
	onUpdate: PropTypes.func,
	passSetItems: PropTypes.func,
};

List.defaultProps = {
	keyPrefix: 'list',
	titleMappings: {},
	onUpdate: () => {},
	passSetItems: () => {},
};
